<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <proposta-form
            v-show="isModalVisible"
            @close="closeModal"
            :proposta="proposta"
          ></proposta-form>
        </div>
        <div class="col-md-4"></div>
      </div>
    </div>
    <template>
      <div class="content">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
              <card
                class="strpied-tabled-with-hover"
                body-classes="table-full-width table-responsive"
              >
                <template slot="header">
                  <div class="float-left">
                    <h4 class="card-title">Propostas Geradas</h4>
                  </div>
                </template>
                <l-table
                  class="table-hover table-striped"
                  :columns="tabelaPropostas.columns"
                  :data="tabelaPropostas.data"
                >
                  <template slot-scope="{ row }">
                    <td>
                      <b>{{ row.codigo }}</b>
                    </td>
                    <td>{{ row.cliente.nome }}</td>
                    <td>{{ getParceiroNome(row.emissor) }}</td>
                    <td>
                      <!-- <button
                        class="btn btn-icon btn-info"
                        style="margin-right: 10px"
                        @click="visualizarProposta(row)"
                      >
                        <i class="fa fa-info"></i>
                      </button> -->
                      <router-link :to="`historico-propostas/${row.codigo}`">
                        <button
                          class="btn btn-icon btn-info"
                          style="margin-right: 10px"
                        >
                          <i class="fa fa-info"></i>
                        </button>
                      </router-link>
                    </td>
                  </template>
                </l-table>
                <template slot="footer">
                  <v-pagination
                    class="pagination"
                    v-if="tabelaPropostas.data.length > 0"
                    v-model="currentPage"
                    :page-count="totalPages"
                    :classes="bootstrapPaginationClasses"
                    :labels="paginationAnchorTexts"
                  ></v-pagination>
                </template>
              </card>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import _ from 'lodash';
import PropostaForm from './Forms/PropostaForm.vue';
import LTable from 'src/components/Table.vue';
import PropostaServices from 'src/services/proposta';
import vPagination from 'vue-plain-pagination';

const VUE_APP_SPINNER_COLOR = process.env.VUE_APP_SPINNER_COLOR;

const tableColumns = ['Código', 'Cliente', 'Parceiro'];
export default {
  components: {
    PropostaForm,
    LTable,
    vPagination
  },
  data() {
    return {
      tabelaPropostas: {
        columns: [...tableColumns],
        data: []
      },
      isModalVisible: false,
      proposta: {},
      isDeleteModalVisible: false,
      currentPage: 1,
      totalPages: 1,
      bootstrapPaginationClasses: {
        ul: 'pagination',
        li: 'page-item',
        liActive: 'active',
        liDisable: 'disabled',
        button: 'page-link'
      },
      paginationAnchorTexts: {
        first: 'Primeira',
        prev: '<',
        next: '>',
        last: 'Última'
      }
    };
  },
  created() {
    this.loadList();
  },
  methods: {
    loadList() {
      const loader = this.$loading.show({
        color: VUE_APP_SPINNER_COLOR
      });

      PropostaServices.listar({ page: this.currentPage })
        .then(response => {
          this.tabelaPropostas.data = _.get(response, 'data.result');
          this.totalItens = _.get(response, 'data.count');
          this.totalPages = Math.ceil(this.totalItens / 10);
          loader.hide();
        })
        .catch(error => {
          loader.hide();

          const message =
            _.get(error, 'response.status') === 400 &&
            _.has(error, 'response.data.message')
              ? _.get(error, 'response.data.message')
              : 'Ocorreu algum erro interno. Tente novamente mais tarde.';

          this.$notifications.notify({
            message,
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'danger',
            icon: 'fa fa-exclamation-triangle'
          });
        });
    },
    visualizarProposta(proposta) {
      this.proposta = { ...proposta };

      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    notifyVue(verticalAlign, horizontalAlign, type, message, icon) {
      this.$notifications.notify({
        message: `<span>${message}.</span>`,
        icon: icon,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type
      });
    },
    getParceiroNome(parceiro) {
      return parceiro.tipoParceiro == 'pf'
        ? `${parceiro.nome} ${parceiro.sobrenome}`
        : parceiro.razaoSocial;
    }
  },
  watch: {
    currentPage: function(newValue, oldValue) {
      if (this.currentPage !== oldValue) {
        this.loadList();
      }
    }
  }
};
</script>
<style scope>
.pagination {
  display: -webkit-box;
}
</style>
